const attachmentFilesEquipmentModelsTypo = {
  label: 'Anexos do Tipo de Equipamento',
  noResults: 'Nenhum resultado encontrado'
};

export default attachmentFilesEquipmentModelsTypo;
